export enum EventStatus {
  pending = 'Da programmare',
  waiting = 'In attesa',
  scheduled = 'Programmato',
  to_be_confirmed = 'In attesa di conferma',
  confirmed = 'Confermato',
  change_request = 'Richiesto spostamento',
  to_be_reschedule = 'Da ripianificare',
  done = 'Effettuato',
  deleted = 'Annullato',
  // Nessuno scrive questo stato (0 record): resta per non rompere eventuali dati storici.
  expired = 'Richiesta conferma scaduta'
}

export interface Event {
  id: number;
  type: 'event' | 'trattamento' | 'mantenimento' | 'checkup' | 'chiusura';
  beauty_type: 'appuntamento generico' | 'note' | 'trattamento' | 'mantenimento' | 'checkup';
  trattamento_id: number;
  description: string;
  data: string;
  dataFine: string;
  cliente: string;
  cliente_id: number;
  stato: 'pending' | 'waiting' | 'scheduled' | 'to_be_confirmed' | 'confirmed' | 'change_request' | 'to_be_reschedule' | 'done' | 'deleted' | 'expired';
  note?: any;
  durata: string;
  in_rubrica: boolean;
  note_cliente?: any;
  confirm_request_sent_at?: string;
  servizio_id?: number;
  servizio_nome?: string;
  operatore_id?: number;
  user?: { id: number; name: string };
}
